//Code taken from https://github.com/Hermanya/use-interval/blob/master/src/index.tsx
// background context of reason for existence of this hook: https://overreacted.io/making-setinterval-declarative-with-react-hooks/

import { useEffect, useRef, useState } from 'react'
import noop from '../utils/noop'

export function useInterval(
  callback: () => void,
  delay: number | null | false,
  immediate?: boolean,
) {
  const savedCallback = useRef(noop)

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback
  })

  // Execute callback if immediate is set.
  useEffect(() => {
    if (!immediate) return
    if (delay === null || delay === false) return
    savedCallback.current()
  }, [delay, immediate])

  // Set up the interval.
  useEffect(() => {
    if (delay === null || delay === false) return undefined
    const tick = () => savedCallback.current()
    const id = setInterval(tick, delay)
    return () => clearInterval(id)
  }, [delay])
}

export default useInterval

export function useCountDownTimer(delayInSeconds: number) {
  const [timer, setTimer] = useState(delayInSeconds)

  useInterval(
    () => {
      setTimer(s => {
        if (s === 0) {
          return s
        } else {
          return s - 1
        }
      })
    },
    timer === 0 ? null : 1 * 1000,
  )

  return timer
}
